/**
 * The Vrelis mark: two bars for the sea, a bottle leaning through the surface, its submerged
 * part refracted. Geometry mirrors brand/build.js (the 92x48 grid); colours come from the
 * --logo-* CSS variables so the mark follows the light/dark theme.
 */
export function Logo({ height = 20, title = "Vrelis" }: { height?: number; title?: string }) {
  return (
    <svg
      className="logo"
      viewBox="0 0 92 48"
      height={height}
      width={(height * 92) / 48}
      role={title ? "img" : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : true}
    >
      <rect x="4" y="22.2" width="36.8" height="3.6" fill="var(--logo-sea)" />
      <rect x="71.5" y="22.2" width="16" height="3.6" fill="var(--logo-sea)" />
      <path d="M46.15 44 H52.85 L62.85 24 H56.15 Z" fill="var(--logo-bottle-deep)" />
      <path d="M49.45 24 H56.15 L66.15 4 H59.45 Z" fill="var(--logo-bottle)" />
    </svg>
  );
}
